<template>
	<div class='display-action'>
		<h2 class='display-header'>{{getText('ChallengeHeader')}}</h2>
		<hr/>
		<div id="challenge-container" v-bind:class="{ active: !loading }"></div>
		<div class='challenge-loader' v-if='loading'>
			<SpinnerOne class='spinner' />
			<h5>{{getText('ChallengeLoadingMessage')}}</h5>
		</div>
	</div>
</template>

<style scoped lang="scss">
	#challenge-container{
		width: 0px;
		height: 0px;

		&.active{
			width: 100%;
			height: 400px;
		}
	}
	.challenge-loader{
		width: 100%;
		height: 400px;
		text-align: center;
		margin-top: 30px;

		.spinner{
			margin-bottom: 20px;
		}
	}
</style>

<script>

import { mapGetters } from "vuex"

import SpinnerOne from "@/components/helpers/SpinnerOne";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "ChallengeAction",
	components: {
		SpinnerOne
	},
	data(){
		return {
			loading: true
		};
	},
	computed: {
		action_data(){
			return this.action().Challenge;
		}
	},
	mounted(){
		this.loading = true;
		// Fire up our challenge iframe script
		window.rch.challenge(
			this.action_data,
			'05',
			document.getElementById("challenge-container"), result => {
				// User submitted challenge form
				if(result.authorized){
					// Success, will fire back and redirect to order screen
					this.$emit('complete', 'true');
					return;
				}
				this.$emit('failure',  this.getError('SecondaryAuthFailed'));
				return;
			},
			() => {
				// Iframe has loaded, show it
				this.loading = false;
			}
		);
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		getError(key){
			return LanguageService.getError(key);
		},
		...mapGetters(["action"])
	}
}
</script>
